export const SET_APP_CONFIG = "SET_APP_CONFIG";
export const SET_MIGRATION_STATUS = "SET_MIGRATION_STATUS";
